import React from 'react';
import { useHotStampingChoice } from 'components/quote_builder_widget/shared/BaseHotStampingChooser';

const HotStampingChooser = ({ widgetIdentifier, cartonMaterialUserPriceId, drawingId, unit }) => {
  const choice = useHotStampingChoice(widgetIdentifier, cartonMaterialUserPriceId, drawingId, unit);

  if (!choice.offered) {
    return null;
  }

  const lengthField = (name, label, value, onChange) => (
    <div className="mb-3" data-widget-element="form-group">
      <div className="input-group">
        <span className="input-group-text font13" data-widget-element="label">{label}</span>
        <input
          type="number"
          name={name}
          min="0"
          step="any"
          required
          value={value}
          onChange={onChange}
          className="form-control text-align-right"
          data-widget-element="input"
        />
        <span className="input-group-text font13" data-widget-element="unit-suffix">{unit}</span>
      </div>
    </div>
  );

  return (
    <>
      <div className="mb-3" data-widget-element="form-group">
        <div className="input-group">
          <span className="input-group-text font13" data-widget-element="label">{t('quote_builder_widget.hot_stamping')}</span>
          <select
            name="hot_stamping_material_user_price_id"
            value={choice.selectedHotStampingMaterialId}
            onChange={choice.onHotStampingMaterialChange}
            className="form-select form-control text-align-right"
            data-widget-element="select"
          >
            <option value="">{t('quote_builder_widget.hot_stamping_none')}</option>
            {choice.hotStampingMaterials.map((hotStampingMaterial) => (
              <option key={hotStampingMaterial.id} value={hotStampingMaterial.id}>{hotStampingMaterial.label}</option>
            ))}
          </select>
        </div>
      </div>
      {choice.selectedHotStampingMaterialId !== '' && (
        <>
          {lengthField('hot_stamping_width', t('quote_builder_widget.hot_stamping_width'), choice.width, choice.onWidthChange)}
          {lengthField('hot_stamping_height', t('quote_builder_widget.hot_stamping_height'), choice.height, choice.onHeightChange)}
          {choice.parts.length > 1 && (
            <div className="mb-3" data-widget-element="form-group">
              <div className="input-group">
                <span className="input-group-text font13" data-widget-element="label">{t('quote_builder_widget.hot_stamping_part')}</span>
                <select
                  name="hot_stamping_part_code"
                  value={choice.selectedPartCode}
                  onChange={choice.onPartChange}
                  className="form-select form-control text-align-right"
                  data-widget-element="select"
                >
                  {choice.parts.map((part) => <option key={part.code} value={part.code}>{part.name}</option>)}
                </select>
              </div>
            </div>
          )}
          {choice.parts.length === 1 && <input type="hidden" name="hot_stamping_part_code" value={choice.selectedPartCode} />}
        </>
      )}
    </>
  );
};

export default HotStampingChooser;
